import type { AxiosError } from 'axios';
import { useState } from 'react';
import { authApi } from '../api/auth.api';
import type { RequestPasswordResetFormValues } from '../schemas/password-reset-schema';
import type { ApiErrorResponse } from '../types/auth.type';
import { getErrorMessage } from '@/core/api/error-messages';

export function useRequestPasswordReset() {
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [isError, setIsError] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const requestReset = async (values: RequestPasswordResetFormValues) => {
    setIsLoading(true);
    setIsError(false);
    try {
      await authApi.requestPasswordReset({ email: values.email });
      setIsSuccess(true);
    } catch (error) {
      const axiosError = error as AxiosError<ApiErrorResponse>;
      const errorCode = axiosError.response?.data?.title || axiosError.response?.data?.type;
      const statusCode = axiosError.response?.status;
      const detail = axiosError.response?.data?.detail;
      const errorMsg = getErrorMessage(errorCode, statusCode, detail);
      setIsError(true);
      setErrorMessage(errorMsg.message);
    } finally {
      setIsLoading(false);
    }
  };

  const reset = () => {
    setIsSuccess(false);
    setIsError(false);
    setErrorMessage('');
  };

  return { requestReset, isLoading, isSuccess, isError, errorMessage, reset };
}
